import moment, { Moment } from 'moment';
import 'moment/locale/ar';
import 'moment/locale/en-gb';
import { getLanguage } from 'utils/language/language';

const locales = new Map([
	['EN', 'en-gb'],
	['AR', 'ar'],
]);

export default function(date?: string | number | Date | Moment) {
	let locale = locales.get(getLanguage()) || 'en-gb';
	return moment(date).locale(locale);
}
